
/* Controller Imports */
import RoleCreateController from './create-role/create.controller';
import RolesListController from './list/list.controller';
import RoleViewDeleteModalController from './view/delete-modal/delete.modal.controller';
import RoleViewController from './view/view.controller';
import RoleViewDetailsController from './view/details/details.users.controller';
import RoleViewEditController from './view/edit/edit.controller';

const roleManagementModule = angular.module('app.roleManagement', [
    "ui.bootstrap",
    "ui.router",
    "gettext"
])
.controller('RoleCreateController', RoleCreateController)
.controller('RolesListController', RolesListController)
.controller('RoleViewDeleteModalController', RoleViewDeleteModalController)
.controller('RoleViewController', RoleViewController)
.controller('RoleViewDetailsController', RoleViewDetailsController)
.controller('RoleViewEditController', RoleViewEditController)
;
export default roleManagementModule.name;